import { Observable } from "rxjs";
import {
    BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS,
    BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS_COMPLETE,
    BRAND_ADMIN_UPDATE_PERMISSIONS,
    BRAND_ADMIN_UPDATE_PERMISSIONS_COMPLETE,
} from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateBrandPermissionsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_ADMIN_UPDATE_PERMISSIONS)
        .map((action) => {
            return action.payload;
        })
        .concatMap((permissions) => {
            return ajax({
                method: "POST",
                body: { permissions },
                url: `${siteConfig.api}/brand/permissions/update`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving permissions") })),
                            {
                                payload: new Error("Error saving permissions"),
                                error: true,
                                type: BRAND_ADMIN_UPDATE_PERMISSIONS_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_ADMIN_UPDATE_PERMISSIONS_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Permissions Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving permissions");

                    if (error?.xhr?.response?.message) {
                        errorMessage = "Error: " + error.xhr.response.message;
                    }

                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit");
                    }

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_ADMIN_UPDATE_PERMISSIONS_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const updateBrandCustomRolesPermissionsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS)
        .map((action) => {
            return { permissions: action.payload.permissions, brandId: action.payload.brandId };
        })
        .concatMap(({ permissions, brandId }) => {
            return ajax({
                method: "PATCH",
                body: { permissions },
                url: `${siteConfig.api}/brand/${brandId}/custom-roles`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving permissions") })),
                            {
                                payload: new Error("Error saving permissions"),
                                error: true,
                                type: BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Permissions Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving permissions");

                    if (error?.xhr?.response?.message) {
                        errorMessage = "Error: " + error.xhr.response.message;
                    }

                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit");
                    }

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_ADMIN_UPDATE_CUSTOM_ROLES_PERMISSIONS_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
